import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// PrimeNG Configuration
import { ConfirmationService, MessageService } from 'primeng/api';

import { MaterialModule } from './material.module';
import { CookieService } from 'ngx-cookie-service';

import { TranslateModule } from '@ngx-translate/core';
import { LOCALE_ID, Inject } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeEn from '@angular/common/locales/en';
import localeSv from '@angular/common/locales/sv';
//import localeDeAt from '@angular/common/locales/de-AT';
registerLocaleData(localeDe, 'de-DE', localeDeExtra);
registerLocaleData(localeEn, 'en-US');
registerLocaleData(localeSv, 'sv-SE');
//registerLocaleData(localeDeAt, 'de-AT'); // de-AT
//registerLocaleData(localeDeAt, 'de-CH'); // de-CH

// import { GalleryModule } from '@ngx-gallery/core'; // Removed for Angular 16 compatibility
// import { LightboxModule } from '@ngx-gallery/lightbox'; // Removed for Angular 16 compatibility
import { NgChartsModule } from 'ng2-charts';

import { AppRoutingModule } from './app-routing.module';

import { environment } from '@env/environment';
import { CoreModule } from '@core';
import { SharedModule } from '@shared';
import { AuthModule } from '@app/auth';

import { ShellModule } from './shell/shell.module';
import { ClientModule } from './client/client.module';
import { ClientEditModule } from './client_edit/client_edit.module';

import { AboutModule } from './about/about.module';
import { SettingsModule } from './settings/settings.module';

import { ImpressumModule } from './impressum/impressum.module';
import { DatenschutzModule } from './datenschutz/datenschutz.module';
import { HelpModule } from './help/help.module';
import { SupportModule } from './support/support.module';
import { StammdatenModule } from './stammdaten/stammdaten.module';
import { AccountCardModule } from './components/account-card/account-card.module';

import { ReportsModule } from './reports/reports.module';
import { KontrolltermineModule } from './kontrolltermine/kontrolltermine.module';

// 1) Import the PAGE module that renders your component
import { StandortEditModule } from './standort_edit/standort_edit.module';

// 2) Also import the FEATURE module (contains ObjektStrukturTreetableComponent & TtDummyComponent)
import { ObjektStrukturTreetableModule } from './components/objekt-struktur-treetable/objekt-struktur-treetable.module';



@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,

    MaterialModule,
    TranslateModule.forRoot(),

    // GalleryModule, // Removed for Angular 16 compatibility
    // LightboxModule, // Removed for Angular 16 compatibility

    CoreModule,
    SharedModule,
    AuthModule,

    ShellModule,
    ReportsModule,
    KontrolltermineModule,
    ClientModule,
    ClientEditModule,
    StandortEditModule,
    ObjektStrukturTreetableModule,

    AboutModule,
    SettingsModule,
    ImpressumModule,
    DatenschutzModule,
    HelpModule,
    SupportModule,
    StammdatenModule,
    AccountCardModule,

    //PhutureLoginModule,
    NgChartsModule,
    

    AppRoutingModule,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'de-DE',
    },
    CookieService,
    ConfirmationService,
    MessageService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
